import { render, staticRenderFns } from "./ReverseLogisticsPackage.vue?vue&type=template&id=6ffcb62d"
import script from "./ReverseLogisticsPackage.vue?vue&type=script&lang=js"
export * from "./ReverseLogisticsPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports